import ReactDOM from 'react-dom/client'

import { PharmacToastProvider } from '@pharmac/ui'
import { App } from './App'
import './i18n/i18n'

const renderApp = async () => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <PharmacToastProvider>
      <App />
    </PharmacToastProvider>
  )
}

renderApp()
